import styled from 'styled-components';

export const LeftBlock = styled.div`
    display: flex;
    width: 50vw;
    height: 265px;
    border-bottom-style: dashed;
    border-left-style: dashed;
    border-bottom-width: 2px;
    border-left-width: 2px;
    border-radius: 50px;
    margin-left: 219px;
    position: relative;
    top: -40px;
    @media screen and (max-width: 1700px){
        margin-left: 105px;
    }
    @media screen and (max-width: 1330px){
        visibility: hidden;
        height: 230px;
    }
`;

export const RightBlock = styled.div`
    display: flex;
    width: 50vw;
    height: 265px;
    border-bottom-style: dashed;
    border-right-style: dashed;
    border-bottom-width: 2px;
    border-right-width: 2px;
    border-radius: 50px;
    position: relative;
    align-self: flex-end;
    margin-right: 216px;
    top: -245px;
    @media screen and (max-width: 1700px){
        margin-right: 105px;
    }
    @media screen and (max-width: 1330px){
        visibility: hidden;
        height: 230px;
    }
`;
